import type { Menu } from '@/menus/types.ts';
export default [
  {
    code: 'CAR_PURCHASE',
    icon: 'menu-car-purchase',
    label: '车源采购',
    children: [
      {
        code: 'CAR_PURCHASE_REQUIREMENT',
        icon: 'menu-default',
        label: '采购需求单',
        path: '/car-purchase/purchase-requirement',
      },
      {
        code: 'CAR_PURCHASE_CONTRACT',
        icon: 'menu-purchase-contract',
        label: '采购合同',
        path: '/car-purchase/purchase-contract',
      },
      {
        disabled: true,
        code: 'CAR_PURCHASE_PREPAYMENT',
        icon: 'menu-purchase-payment',
        label: '采购预付',
        path: '/car-purchase/purchase-prepayment',
      },
      {
        disabled: true,
        code: 'CAR_PURCHASE_FINANCING_QUOTATION',
        icon: 'menu-payment-current-account',
        label: '垫资报价单',
        path: '/car-purchase/financing-quotation',
      },
      {
        disabled: true,
        code: 'CAR_PURCHASE_DEPOSIT',
        icon: 'menu-payment-deposit',
        label: '采购定金',
        path: '/car-purchase/purchase-deposit',
      },
      {
        code: 'CAR_PURCHASE_CONTRACT_PAYMENT',
        icon: 'menu-purchase-payment',
        label: '采购付款',
        path: '/car-purchase/contract-payment',
      },
    ],
  },
] satisfies Menu[];
